// extracted by mini-css-extract-plugin
export var createdDate = "_kz-1";
export var divider = "_kz-2";
export var headerDivider = "_kz-3";
export var messagesCard = "_kz-0";
export var messagesContainer = "_kz-6";
export var messagesContainerWrapper = "_kz-4";
export var showLeftPanelButton = "_kz-8";
export var topButtons = "_kz-7";
export var withPadding = "_kz-5";